module.exports = __webpack_public_path__ + "static/images/biditem6_d8a459fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem6.png
// module id = 245
// module chunks = 1